module.exports = __webpack_public_path__ + "img/carpenter.1ada5aac.jpg";